import React from 'react'

const GuestUserPage = () => {
    return (
        <div className='d-flex justify-content-center'>
          <h2 className='text-danger'>This is guest user page category select option available here</h2>
        </div>
    )
}

export default GuestUserPage
